import axios from '../Backend';
// import axios from 'axios';

export const fetchCallerId = async (phone) => {
    try {
        const response = await axios.get(`/api/v2/dialLists/get-id-by-phone?phone=${phone}`);
        const resData = response?.data?.data?.callerId;
        return resData !== 'ID Not Found' ? resData : undefined;
    } catch (error) {
        console.error('Error fetching caller ID:', error);
        return undefined;
    }
};
